import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ConfigService, FormsUtilsService } from '../../../../../core';
import { ConfigEmpresa } from '../../../../configuracoes/app/empresa';
import { ConfigCliente } from '../../../../configuracoes/app/cliente';
import { ClienteInterneter } from '../cliente-interneter';
import { ClienteECommerceComponent } from '../ecommerce';
import { isClienteCadastroCliente, isClienteCadastroProspect } from '../../cadastro';

@Component({
    selector: 'sgt-cliente-internet-form',
    templateUrl: './cliente-internet-form.component.html',
    styleUrls: ['./cliente-internet-form.component.less']
})
export class ClienteInternetFormComponent implements OnInit {
    configEmpresa: ConfigEmpresa;
    configCliente: ConfigCliente;

    /** Se pode editar os dados do form */
    @Input() canEdit = true;
    @Input() entity: ClienteInterneter;
    @Input() site: string
    @Output() siteChange = new EventEmitter<string>();
    @Input() emailNfeRequired = false; // Se o e-mail nf-e deve ser obrigatório

    @ViewChild('form') form: NgForm;
    @ViewChild('clienteECommerceCadastro') clienteECommerceCadastro: ClienteECommerceComponent;

    constructor(private configService: ConfigService,
                private formsUtilsService: FormsUtilsService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.configCliente = this.configService.getCliente();
    }

    /** Verifica se é um Prospect */
    private isProspect(): boolean {
        return isClienteCadastroProspect(this.entity?.cadastro);
    }

    /** Verifica se deve obrigar ou não a informar o e-mail NF-e no cliente */
    isEmailNfeRequired(): boolean {
        // Prospect
        if (this.isProspect()) {
            return this.configCliente?.obrigarEmailNfeProspect;
        }

        return this.emailNfeRequired || this.configCliente?.obrigarEmailNfe;
    }

    /** Verifica se deve obrigar ou não a informar o laudo no cliente */
    isLaudoRequired(): boolean {
        // Prospect
        if (this.isProspect()) {
            return this.configCliente?.obrigarLaudoProspect;
        }

        return this.configCliente?.obrigarLaudo;
    }

    /** Ao alterar a opção de laudo (enviar laudo) */
    onChangeEnviarLaudo() {
        if (!this.entity) {
            return;
        }
        if (this.entity.laudo) {
            setTimeout(() => jQuery('#emailLaudo').focus(), 200);
        }
    }

    /** Ao alterar o site */
    onChangeSite(site: string) {
        this.siteChange.emit(site);
    }

    /** Verifica se o cliente possui e-commerces através das flags de possui ou não e-commerce, Mercado Livre ou marketplaces */
    possuiEcommerces(): boolean {
        if (!this.entity) {
            return false;
        }

        // Se o cliente possuir e-commerce ou mercado livre ou marketplace, então exibimos a listagem para cadastrar os e-commerces
        return this.entity.ecommerce || this.entity.mercadoLivre || this.entity.marketplace;
    }

    /** Verifica se o formulário está válido */
    isValid(): boolean {
        if (!this.canEdit) {
            return true;
        }

        this.formsUtilsService.makeAllFieldsDirty(this.form);

        // E-commerces
        if (this.clienteECommerceCadastro && !this.clienteECommerceCadastro.isValid()) {
            return false;
        }

        return this.form.valid;
    }

    /** Método para excutar antes de salvar as informações de internet do cliente  */
    beforeSave() {
        // E-Commerces
        if (!this.possuiEcommerces()) {
            this.entity.eCommerces = [];
        }
    }
}
